const error = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return <p {...attributes}>Error{children}Error</p>;
    },
};

export default error;
